<template>
  <v-container class="pt-10 pb-16 page-privacy">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <h1 class="page-title mb-4">OH YES LLC – PRIVACY POLICY</h1>

        <section>
          <h3>1. INTRODUCTION</h3>
          <p>OH YES LLC ("Company," "we," "us," or "our") respects your privacy and is committed to protecting it through our compliance with this policy. This policy describes the types of information we may collect from you when you use the OhYes mobile application or website (the "Platform").</p>
        </section>

        <section>
          <h3>2. INFORMATION WE COLLECT</h3>
          <p>To facilitate our aggregator services, we collect several types of information:</p>
          <ul>
            <li><strong>Personal Identifiers:</strong> Name, postal address, email address, and telephone number.</li>
            <li><strong>Geolocation Data:</strong> We collect precise real-time location from your mobile device to match you with nearby Service Partners.</li>
            <li><strong>Transaction Data:</strong> Details of the service bookings you make, including the nature of the repair, photos of the issue, and scheduling times.</li>
            <li><strong>Financial Data:</strong> Payment information is processed via secure third-party gateways (e.g., Stripe/Apple Pay). OH YES LLC does not store your full credit card or bank account numbers.</li>
          </ul>
        </section>

        <section>
          <h3>3. HOW WE USE YOUR INFORMATION</h3>
          <p>We use your information to:</p>
          <ul>
            <li>Connect you with independent Service Partners for on-site inspections and repairs.</li>
            <li>Provide "Average Cost" estimates based on your local market data.</li>
            <li>Communicate service updates, price confirmations, and emergency alerts.</li>
            <li>Comply with local health mandates (e.g., pandemic safety reporting).</li>
          </ul>
        </section>

        <section>
          <h3>4. SHARING DATA WITH SERVICE PARTNERS</h3>
          <p>Because we are an aggregator, we must share your information with third parties to fulfill your request:</p>
          <ul>
            <li><strong>Operational Sharing:</strong> We share your name, address, phone number, and service photos with the Service Partner (independent contractor) assigned to your job.</li>
            <li><strong>Limited Purpose:</strong> Partners are contractually prohibited from using your data for any purpose other than providing the requested service.</li>
          </ul>
        </section>

        <section>
          <h3>5. YOUR PRIVACY RIGHTS (CCPA/CPRA - CALIFORNIA & BEYOND)</h3>
          <p>Under US state laws, you have specific rights regarding your data:</p>
          <ul>
            <li><strong>Right to Know/Access:</strong> You can request a list of the personal data we have collected about you over the past 12 months.</li>
            <li><strong>Right to Delete:</strong> You may request that we delete your personal information (subject to legal exceptions like tax or fraud records).</li>
            <li><strong>Mandatory Opt-Out Confirmation (2026 Update):</strong> We do not sell your data. However, if you choose to "Opt-Out" of data sharing for marketing, our Platform will provide a visible confirmation in your account settings that your request has been honored.</li>
            <li><strong>Right to Correct:</strong> You may request that we correct inaccurate personal information.</li>
          </ul>
        </section>

        <section>
          <h3>6. DATA SECURITY</h3>
          <p>We implement industry-standard security measures, including SSL/TLS encryption for data in transit. However, because we share data with independent Service Partners to perform work, we cannot guarantee the security practices of those individual contractors once they receive your service address.</p>
        </section>

        <section>
          <h3>7. RETENTION POLICY</h3>
          <p>We retain your personal data for as long as your account is active or as needed to provide you services. For legal and tax compliance (especially for high-value construction or plumbing work), we may retain transaction records for up to 7 years.</p>
        </section>

        <section>
          <h3>8. CHILDREN UNDER THE AGE OF 13</h3>
          <p>Our Platform is not intended for children under 13 years of age. We do not knowingly collect personal information from children.</p>
        </section>

        <section>
          <h3>9. CONTACT INFORMATION</h3>
          <p>To exercise your privacy rights or ask questions about this policy, please contact us at:</p>
          <p><strong>OH YES LLC</strong></p>
          <ul>
            <li><strong>Email:</strong> [Insert Support Email]</li>
            <li><strong>Address:</strong> [Insert Des Plaines, IL Address]</li>
          </ul>
        </section>

        <section>
          <h3>Important Implementation Tips for your App</h3>
          <ul>
            <li><strong>In-App Disclosure:</strong> Google and Apple now require a "Just-in-Time" disclosure. For example, when the app asks for location permission, show a small pop-up saying: "We use your location to find the nearest repair technician and provide accurate price estimates."</li>
            <li><strong>Delete Account Button:</strong> Ensure there is a clearly visible button in the "Profile" section of your app that allows users to initiate an account deletion.</li>
          </ul>
        </section>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PrivacyPolicyUs",
};
</script>

<style scoped>
.page-title { font-size: 34px; font-weight: 700; }
section { margin-bottom: 28px; }
h3 { font-size: 16px; font-weight: 600; margin-top: 18px; margin-bottom: 6px; }
p, li { font-size: 15px; color: #444; line-height: 1.7; }
ul { padding-left: 20px; }
</style>
